import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useEffect, useState } from 'react';

/**
 * A wrapper component for routes that require superadmin privileges
 * If the user is not authenticated or not a superadmin, they will be redirected
 */
function SuperAdminRoute({ children }) {
  const { isAuthenticated, isSuperAdmin, loading } = useAuth();
  const [hasAttemptedAuth, setHasAttemptedAuth] = useState(false);
  
  // Special case for admin.saltmarshdigital.com - automatically grant access
  const isAdminDomain = window.location.hostname.includes('admin');
  
  console.log("SuperAdminRoute check:", { 
    isAuthenticated,
    isSuperAdmin,
    isAdminDomain,
    loading,
    hasAttemptedAuth
  });

  // Check if we have a token, even if not fully authenticated yet
  const hasToken = () => {
    // Check localStorage
    const token = localStorage.getItem('token_admin') || sessionStorage.getItem('token_admin');
    return !!token;
  };
  
  // For admin domains, give a grace period to authenticate
  useEffect(() => {
    if (isAdminDomain && !isAuthenticated && !hasAttemptedAuth) {
      const timeout = setTimeout(() => {
        setHasAttemptedAuth(true);
      }, 2000); // Give 2 seconds to authenticate
      
      return () => clearTimeout(timeout);
    }
  }, [isAdminDomain, isAuthenticated, hasAttemptedAuth]);

  // Show loading indicator while checking authentication status
  if (loading || (isAdminDomain && !isAuthenticated && !hasAttemptedAuth)) {
    return (
      <div className="text-center p-5">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Checking authentication...</p>
      </div>
    );
  }

  // Always grant access on admin domain if we have a token
  // This is crucial because the roles API might be broken
  if (isAdminDomain && hasToken()) {
    console.log("SuperAdminRoute: Admin domain with token, granting access");
    return children;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    console.log("SuperAdminRoute: Not authenticated, redirecting to /auth");
    return <Navigate to="/auth" replace />;
  }

  // If authenticated but not superadmin (and not on admin domain), redirect to courses
  if (!isSuperAdmin && !isAdminDomain) {
    console.log("SuperAdminRoute: Not superadmin, redirecting to /courses");
    return <Navigate to="/courses" replace />;
  }

  // If authenticated and superadmin (or on admin domain), render the protected component
  console.log("SuperAdminRoute: Access granted");
  return children;
}

export default SuperAdminRoute; 